export default __webpack_public_path__ + "static/media/comici.9b89f236.ttf";